import script from "./messagePanel.vue?vue&type=script&lang=js"
export * from "./messagePanel.vue?vue&type=script&lang=js"

import "./messagePanel.vue?vue&type=style&index=0&id=07a34946&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07a34946"]])

export default __exports__